<form [formGroup]="addressForm" class="w-full relative" (submit)="onSubmit()">
  <h2 class="font-bold">Adresse</h2>
  <div class="absolute top-0 right-0" id="address_geocoder"></div>
  <fieldset class="bm-fieldset">
    <label class="bm-fieldset-label"> Firma </label>
    <input class="bm-input w-full" formControlName="company" />

    @if (editName) {
      <label class="bm-fieldset-label"> Name </label>
      <div class="flex flex-row gap-2">
        <input class="bm-input flex-1" formControlName="firstname" placeholder="Vorname" />
        <input class="bm-input flex-1" formControlName="lastname" placeholder="Nachname" />
      </div>
    }

    <label class="bm-fieldset-label">Straße</label>
    <input class="bm-input w-full" formControlName="street" />

    <label class="bm-fieldset-label">PLZ / Ort</label>
    <div class="flex flex-row gap-2">
      <input class="flex-1 bm-input" formControlName="zip" placeholder="PLZ" />
      <input class="flex-2 bm-input" formControlName="city" />
    </div>

    <label class="bm-fieldset-label">Land</label>
    <input class="bm-input w-full" formControlName="country" />

    <label class="bm-fieldset-label">Staat</label>
    <input class="bm-input w-full" formControlName="state" />
  </fieldset>
  <div class="flex flex-row justify-end gap-2 mt-4">
    <button type="button" class="bm-btn" (click)="onAbortEvent.emit()">Abbrechen</button>
    <button class="bm-btn bm-btn-primary" [disabled]="!addressForm.valid">Speichern</button>
  </div>
</form>
